import { SalePromotionController as controller } from './sale-promotion.controller'
import template from './sale-promotion.html'

export const SalePromotionComponent = {
  controller,
  template,
}
